import React from "react";
import SignUp from "../components/Signup";

const SignupPage = () => {
  return (
    <>
      <SignUp />
    </>
  );
};

export default SignupPage;
